import { render, staticRenderFns } from "./collect_list.vue?vue&type=template&id=407ad64c&scoped=true&"
import script from "./collect_list.vue?vue&type=script&lang=js&"
export * from "./collect_list.vue?vue&type=script&lang=js&"
import style0 from "./collect_list.vue?vue&type=style&index=0&id=407ad64c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ad64c",
  null
  
)

export default component.exports